<template>
  <header>
    <!-- sidebar -->
    <shop-sidebar ref="sidebar">
      <div class="sidebar-header">
        <h3>{{$store.state.shop.name}}</h3>
      </div>
      <ul class="list-unstyled sidebar-content">
        <!-- <p>{{$store.state.account.name}}</p> -->
        <li>
          <router-link
            :to="'/shop/'+$route.params.shopid+'/orders'"
            @click.native="closeSidebar"
          >即時訂單</router-link>
        </li>
        <li>
          <router-link
            :to="'/shop/'+$route.params.shopid+'/meal'"
            @click.native="closeSidebar"
          >點餐</router-link>
        </li>
        <!-- <li>
          <a href="#">今日總覽</a>
        </li> -->
        <li class="active">
          <a v-b-toggle.collapse-order>訂單管理 <i class="fas fa-angle-down"></i></a>
          <b-collapse
            id="collapse-order"
            class="mt-2"
            accordion="sidebar-accordion"
          >
            <ul class="list-unstyled">
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/orders'"
                  @click.native="closeSidebar"
                >即時訂單</router-link>
              </li>
              <li>
                 <router-link
                  :to="'/shop/'+$route.params.shopid+'/reservations'"
                  @click.native="closeSidebar"
                >預約訂單</router-link>
              </li>
              <li>
                <a class="router-link-exact-active router-link-active"  @click="goPermissionPage('/shop/'+$route.params.shopid+'/history')">歷史訂單</a>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li>
          <a v-b-toggle.collapse-shop>店家管理 <i class="fas fa-angle-down"></i></a>
          <b-collapse
            id="collapse-shop"
            class="mt-2"
            accordion="sidebar-accordion"
          >
            <ul class="list-unstyled">
              <li>
                <a class="router-link-exact-active router-link-active"  @click="goPermissionPage('/shop/'+$route.params.shopid+'/info')">店家資訊</a>
              </li>
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/discount'"
                  @click.native="closeSidebar"
                >優惠管理</router-link>
              </li>
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/shopMenu'"
                  @click.native="closeSidebar"
                >菜單管理</router-link>
              </li>
              <!-- <li>
                <a href="#">優惠券設定</a>
              </li> -->
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/comment'"
                  @click.native="closeSidebar"
                >查看評價</router-link>
              </li>
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/permission'"
                  @click.native="closeSidebar"
                >權限管理</router-link>
              </li>
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/authority'"
                  @click.native="closeSidebar"
                >店家端權限管理</router-link>
              </li>
              <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/stock'"
                  @click.native="closeSidebar"
                >庫存管理</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li>
          <a v-b-toggle.collapse-analysis>統計分析 <i class="fas fa-angle-down"></i></a>
          <b-collapse
            id="collapse-analysis"
            class="mt-2"
            accordion="sidebar-accordion"
          >
            <ul class="list-unstyled">
              <li>
                <a class="router-link-exact-active router-link-active"  @click="goPermissionPage('/shop/'+$route.params.shopid+'/analysis')">營運分析</a>
              </li>
              <!-- <li>
                <router-link
                  :to="'/shop/'+$route.params.shopid+'/resource'"
                  @click.native="closeSidebar"
                >進銷存管理</router-link>
              </li> -->
              <!-- <li>
                <a href="#">成本原物料控管</a>
              </li> -->
            </ul>
          </b-collapse>
        </li>
        <li>
          <a v-b-toggle.collapse-financ>帳務 <i class="fas fa-angle-down"></i></a>
          <b-collapse
            id="collapse-financ"
            class="mt-2"
            accordion="sidebar-accordion"
          >
            <ul class="list-unstyled">
              <li>
                <a class="router-link-exact-active router-link-active"  @click="goPermissionPage('/shop/'+$route.params.shopid+'/yumCoin')">Yum幣</a>
              </li>
              <li>
                <a class="router-link-exact-active router-link-active"  @click="goPermissionPage('/shop/'+$route.params.shopid+'/bill')">帳單管理</a>
              </li>
              <!-- <li>
                <router-link>收款</router-link>
              </li>
              <li>
                <router-link>付款</router-link>
              </li>
              <li>
                <router-link>帳單</router-link>
              </li> -->
            </ul>
          </b-collapse>
        </li>
        <li>
          <router-link
            :to="'/shop/'+$route.params.shopid+'/Help'"
            @click.native="closeSidebar"
          >幫助</router-link>
        </li>
        <!-- <li>
          <a href="#">優惠情報</a>
        </li> -->
        <li>
          <a
            href="#"
            @click="logout"
          >登出</a>
        </li>
      </ul>
    </shop-sidebar>
    <!-- header-->
    <div>
      <b-navbar type="dark">
        <b-navbar-brand href="#">
          <span
            class="nav-back"
            @click="goBack"
          >
            <i class="fas fa-angle-left"></i>
          </span>
          <span class="nav-title">
            {{title}}
          </span>
        </b-navbar-brand>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="goShopDefaultPage">
            <span class="navShopName">{{HAS_CHOSEN ? $store.state.shop.name : ''}}</span>
          </b-nav-item>
          <b-nav-item
            @click="openSidebar"
            :style="{ visibility: HAS_CHOSEN ? 'visible' : 'hidden' }"
          >
            <span class="navShopIcon">
              <i class="fas fa-align-justify"></i>
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
    <b-modal
      id="check-passwd-modal"
      hide-footer
      hide-header
      centered
    >
      <div>
        <div class="w-100 text-center mt-3">此頁面需要密碼驗證，請輸入密碼：</div>
      </div>
      <div>
        <b-input
          type="text"
          class="table-no-input text-center my-1 mx-auto"
          maxlength="6"
          v-model="passwd"
        />
      </div>
      <div class="d-flex">
        <b-button
          variant="outline-orange"
          class="w-50 mr-1"
          @click="$bvModal.hide('check-passwd-modal')"
        >
          取消
        </b-button>
        <b-button
          variant="orange"
          class="w-50 ml-1"
          @click="checkPasswd"
        >
          確定
        </b-button>
      </div>
    </b-modal>
  </header>
</template>

<script>
import ShopSidebar from './Sidebar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'shop-header',
  components: { ShopSidebar },
  props: ['shop'],
  created () {
    this.registerTitleChangeHandler()
    let _shopId = this.$route.params.shopid
    if (_shopId && _shopId !== this.$store.state.shop.id) {
      this.getShopInfo()
    }
  },
  beforeDestroy () {
    this.unregisterTitleChangeHandler()
  },
  data () {
    return {
      title: '',
      passwd: '',
      pageurl: ''
    }
  },
  methods: {
    getShopInfo: function () {
      let _id = this.$route.params.shopid
      return this.$api(this, { method: 'get', url: '/api/Restaurants/' + _id + '/Info', authRedirect: true }).then(response => {
        this.$store.commit('shop/SET_CHOSEN_SHOP', response.data)
      })
    },
    goBack () {
      let _current = this.$router.history.current.name
      if (_current === 'ShopList') {
        this.$router.push('/')
      } else if (_current === 'ShopOrders') {
        this.$router.push('/shop/list')
      } else {
        this.$router.push('/shop/' + this.$route.params.shopid + '/orders')
      }
    },
    goShopDefaultPage () {
      let _current = this.$router.history.current.name
      if (_current !== 'ShopOrders') {
        this.$router.push('/shop/' + this.$route.params.shopid + '/orders')
      }
    },
    openSidebar () {
      this.$refs.sidebar.openSidebarPanel()
    },
    closeSidebar () {
      this.$refs.sidebar.closeSidebarPanel()
    },
    logout () {
      this.$store.dispatch('account/LOGOUT')
      this.$router.push('/')
    },
    registerTitleChangeHandler (data) {
      this.$eventHub.$on('header-title-change', (data) => {
        this.title = data
      })
    },
    unregisterTitleChangeHandler () {
      this.$eventHub.$off('header-title-change')
    },
    goPermissionPage: async function (pageurl) {
      var _url = '/api/Restaurants/' + this.$route.params.shopid + '/Password'
      let response = await this.$api(this, {method: 'get', url: _url})
      if (!response.data.isSetEmployerPassword) {
        this.$router.push(pageurl)
      } else {
        this.pageurl = pageurl
        this.$bvModal.show('check-passwd-modal')
        this.closeSidebar()
      }
    },
    checkPasswd: async function () {
      console.log('checkPasswd')
      let data = {password: this.passwd}
      let _url = '/api/Restaurants/' + this.$route.params.shopid + '/Password/Verify'

      let response = await this.$api(this, {method: 'put', url: _url, data})
      console.log(response)
      if (!response.data.result) {
        this.$bvModal.msgBoxOk('密碼輸入錯誤。')
        this.$bvModal.hide('check-passwd-modal')
      } else {
        this.$bvModal.hide('check-passwd-modal')
        this.closeSidebar()
        this.$router.push(this.pageurl)
      }
      this.passwd = ''
    }
  },
  computed: {
    ...mapGetters('shop', [
      'HAS_CHOSEN'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

header {
  background-color: $papayum_orange;
  nav {
    padding: 0px 10px;
    height: 2rem;
    .nav-link,
    .navbar-brand {
      padding: 0px;
    }
    .nav-back,
    .nav-title {
      padding: 0px 10px;
    }
    .nav-title {
      cursor: default;
    }
    .navShopName {
      color: $basic-white;
    }
    .navShopIcon {
      color: $basic-white;
    }
  }
  a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/Header.vue